import React, { useState } from 'react';
import './assets/styles/global.css';
import MyProjects from './sections/Projects';
import MyProjectsEnglish from './EnglishSections/Projects';
import WhoAmIPage from './sections/WhoAmIPage';
import WhoAmIPageEnglish from './EnglishSections/WhoAmIPage';
import ContactMe from './sections/Contact';
import ContactMeEnglish from './EnglishSections/Contact';
import Header from './components/Header';
import EnglishHeader from './components/EnglishHeader'
import GoToTopButton from './components/GoToTopButton';
import FloatSocialMedias from './components/SocialMedias';

function App() {
  const [language, setLanguage] = useState("Portuguese");

  function handleSetPortugueseLanguage() {
    setLanguage( "Portuguese" )
  }

  function handleSetEnglishLanguage() {
    setLanguage( "English" )
  }

  let renderTraslatedPortfolio;

  if(language === "Portuguese"){
    renderTraslatedPortfolio = ( <>
      <Header setPortuguese={handleSetPortugueseLanguage} setEnglish={handleSetEnglishLanguage} />
      <FloatSocialMedias/>
      <WhoAmIPage/>
      <MyProjects/>
      <ContactMe/>
      <GoToTopButton/>
    </>)
  } else if (language === "English"){
    renderTraslatedPortfolio = ( <>
      <EnglishHeader setPortuguese={handleSetPortugueseLanguage} setEnglish={handleSetEnglishLanguage} />
      <FloatSocialMedias/>
      <WhoAmIPageEnglish/>
      <MyProjectsEnglish/>
      <ContactMeEnglish/>
      <GoToTopButton/>
    </>)
  }

  return (
    <div className="container">
      {renderTraslatedPortfolio}
    </div>
  );
}

export default App;                                                                                                                                             